(function() {
    const container = document.getElementById('shippingInfoContainer');
    if (!container || container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    const header = container.querySelector('.shipping-info-header');
    const toggle = container.querySelector('.shipping-info-toggle');
    const content = container.querySelector('.shipping-info-content');

    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', !isExpanded);
      toggle.setAttribute('aria-expanded', !isExpanded);
      content.hidden = isExpanded;
    });

    // Thresholds in Rappen (CHF cents). The snippet passes the flag image
    // URLs via data attributes because this file is a plain .js asset with
    // no Liquid processing.
    const MIN_ORDER_THRESHOLD = 5000;
    const CH_FREE_SHIPPING_THRESHOLD = 5000;
    const EU_FREE_SHIPPING_THRESHOLD = 18000;
    const INTL_FREE_SHIPPING_THRESHOLD = 22000;
    const CH_FEE = 850;
    const EU_FEE = 1875;
    const INTL_FEE_FROM = 2900;
    const CONVERSION_FEE = 1.02;
    const ROUND_UP = { EUR: [100, 95], JPY: [10000, 0], KRW: [100000, 0] };
    const CH_COUNTRIES = ['CH', 'LI'];
    const EU_COUNTRIES = ['AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'GB', 'IE', 'IT', 'NL', 'NO', 'PL', 'PT', 'SE'];
    const INTL_COUNTRIES = ['AE', 'AU', 'CA', 'HK', 'IL', 'JP', 'KR', 'MY', 'NZ', 'SG'];
    const methodsContainer = document.getElementById('shippingMethodsContainer');
    const flags = methodsContainer ? methodsContainer.dataset : {};
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const text = (key, fallback) => esc(flags[key] || fallback);
    const L = {
      chZone: text('tChZone', 'Schweiz & Liechtenstein'),
      euZone: text('tEuZone', 'Europa (ausgewählte Länder)'),
      intlZone: text('tIntlZone', 'International (ausgewählte Länder)'),
      chAlt: text('tChAlt', 'Schweizer Flagge'),
      euAlt: text('tEuAlt', 'Europa'),
      intlAlt: text('tIntlAlt', 'Welt'),
      chStd: text('tChStd', 'Standard (1-2 Werktage)'),
      chExp: text('tChExp', 'Express (1 Werktag)'),
      euStd: text('tEuStd', 'Standard (2-4 Werktage)'),
      intlStd: text('tIntlStd', 'Standard (3-7 Werktage)'),
      free: text('tFree', 'Kostenlos'),
      expFrom: text('tExpFrom', 'ab Bestellwert CHF 50'),
      intlFrom: text('tIntlFrom', 'ab {amount}'),
      left: text('tLeft', 'Noch {amount} bis zum kostenlosen Versand'),
      done: text('tDone', '✓ Du erhältst kostenlosen Versand!')
    };
    let money = formatCHF;
    let conv = { threshold: (c) => c, fee: (c) => c };
    const amount = (cents) => esc(money(cents));
    const leftTo = (cents) => L.left.replace('{amount}', '<strong>' + amount(cents) + '</strong>');
    const zoneOf = (country) => CH_COUNTRIES.includes(country) ? 'ch' : EU_COUNTRIES.includes(country) ? 'eu' : INTL_COUNTRIES.includes(country) ? 'intl' : '';

    function formatCHF(cents) {
      return 'CHF ' + (cents / 100).toFixed(2);
    }

    function moneyFormatter(currency) {
      if (currency === 'CHF') return formatCHF;
      const m = String(flags.moneySample || '').match(/^([\s\S]*?)1([^0-9]?)234\2(?:567([^0-9])89|568)([\s\S]*)$/);
      if (m) {
        return (cents) => {
          const whole = m[3] ? Math.floor(cents / 100) : Math.round(cents / 100);
          const digits = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
          return m[1] + digits + (m[3] ? m[3] + String(cents % 100).padStart(2, '0') : '') + m[4];
        };
      }
      try {
        const nf = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: currency });
        return (cents) => nf.format(cents / 100);
      } catch (e) {
        return (cents) => currency + ' ' + (cents / 100).toFixed(2);
      }
    }

    function converter(currency) {
      if (currency === 'CHF') return { threshold: (c) => c, fee: (c) => c };
      const active = window.Shopify && window.Shopify.currency;
      const rate = active && active.active === currency ? Number(active.rate) : NaN;
      if (!(rate > 0)) return null;
      const step = ROUND_UP[currency] || [100, 0];
      return {
        threshold: (c) => Math.ceil((Math.ceil(c * rate / CONVERSION_FEE) - step[1]) / step[0]) * step[0] + step[1],
        fee: (c) => Math.ceil((Math.round(c * rate) - step[1]) / step[0]) * step[0] + step[1]
      };
    }

    function generateShippingMethodsHTML(cartTotal, zone) {
      const minOrder = conv.threshold(MIN_ORDER_THRESHOLD);
      const chFree = conv.threshold(CH_FREE_SHIPPING_THRESHOLD);
      const euFree = conv.threshold(EU_FREE_SHIPPING_THRESHOLD);
      const intlFree = conv.threshold(INTL_FREE_SHIPPING_THRESHOLD);
      let chShippingHTML = `
        <div class="shipping-method-group ch-shipping">
          <div class="shipping-country-icon">
            <img src="${flags.flagCh || ''}" alt="${L.chAlt}" class="country-flag">
            <span>${L.chZone}</span>
          </div>
          <div class="shipping-method-details">
            <div class="shipping-method-row">
              <div class="shipping-method-type">
                <span class="method-name">${L.chStd}</span>
                ${cartTotal < minOrder ? '<span class="shipping-tag">' + amount(conv.fee(CH_FEE)) + '</span>' : '<span class="shipping-tag free">' + L.free + '</span>'}
              </div>
            </div>
            <div class="shipping-method-row">
              <div class="shipping-method-type">
                <span class="method-name">${L.chExp}</span>
                ${cartTotal < minOrder ? '<span class="shipping-tag">' + L.expFrom + '</span>' : '<span class="shipping-tag free">' + L.free + '</span>'}
              </div>
            </div>
            ${cartTotal < chFree
              ? `<div class="shipping-threshold-message min-order"><span>${leftTo(chFree - cartTotal)}</span></div>`
              : `<div class="shipping-threshold-message success"><span>${L.done}</span></div>`
            }
          </div>
        </div>`;

      let euShippingHTML = `
        <div class="shipping-method-group eu-shipping">
          <div class="shipping-country-icon">
            <img src="${flags.flagEu || ''}" alt="${L.euAlt}" class="country-flag">
            <span>${L.euZone}</span>
          </div>
          <div class="shipping-method-details">
            <div class="shipping-method-row">
              <div class="shipping-method-type">
                <span class="method-name">${L.euStd}</span>
                ${cartTotal >= euFree ? '<span class="shipping-tag free">' + L.free + '</span>' : '<span class="shipping-tag">' + amount(conv.fee(EU_FEE)) + '</span>'}
              </div>
            </div>
            ${cartTotal < euFree
              ? `<div class="shipping-threshold-message"><span>${leftTo(euFree - cartTotal)}</span></div>`
              : `<div class="shipping-threshold-message success"><span>${L.done}</span></div>`
            }
          </div>
        </div>`;

      let intlShippingHTML = `
        <div class="shipping-method-group intl-shipping">
          <div class="shipping-country-icon">
            <img src="${flags.flagWorld || ''}" alt="${L.intlAlt}" class="country-flag">
            <span>${L.intlZone}</span>
          </div>
          <div class="shipping-method-details">
            <div class="shipping-method-row">
              <div class="shipping-method-type">
                <span class="method-name">${L.intlStd}</span>
                ${cartTotal >= intlFree ? '<span class="shipping-tag free">' + L.free + '</span>' : '<span class="shipping-tag">' + L.intlFrom.replace('{amount}', amount(conv.fee(INTL_FEE_FROM))) + '</span>'}
              </div>
            </div>
            ${cartTotal < intlFree
              ? `<div class="shipping-threshold-message"><span>${leftTo(intlFree - cartTotal)}</span></div>`
              : `<div class="shipping-threshold-message success"><span>${L.done}</span></div>`
            }
          </div>
        </div>`;

      if (zone === 'ch') return chShippingHTML;
      if (zone === 'eu') return euShippingHTML;
      if (zone === 'intl') return intlShippingHTML;
      return chShippingHTML + euShippingHTML + intlShippingHTML;
    }

    function updateShippingInfo(cart) {
      if (!methodsContainer) return;
      const currency = cart.currency || 'CHF';
      const found = converter(currency);
      if (!found) {
        methodsContainer.innerHTML = '';
        return;
      }
      conv = found;
      money = moneyFormatter(currency);
      const total = typeof cart.total_price === 'number' ? cart.total_price : cart.original_total_price;
      const country = flags.country || (window.Shopify && window.Shopify.country) || '';
      methodsContainer.innerHTML = generateShippingMethodsHTML(total, zoneOf(country));
    }

    document.addEventListener('cart:updated', (evt) => updateShippingInfo(evt.detail.cart));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
        if (evt && evt.cartData && typeof evt.cartData.total_price === 'number') updateShippingInfo(evt.cartData);
      });
    }
    fetch('/cart.js').then(res => res.json()).then(cart => updateShippingInfo(cart));
  })();
